import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  HostListener,
  AfterViewInit
} from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from '../services/course.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {

  // Horizontal testimonials scroll
  @ViewChild('testimonials', { read: ElementRef })
  public testimonials!: ElementRef;

  // Full page sections
  @ViewChildren('section')
  sections!: QueryList<ElementRef>;

  public topCourses: any[] = [];

  private currentIndex = 0;
  private isScrolling = false;

  constructor(
    private router: Router,
    private courseService: CourseService
  ) { }

  // ==============================
  // INIT
  // ==============================

  ngOnInit(): void {
    this.courseService.topCourses().subscribe((res: any) => {
      this.topCourses = res;
    });
  }

  ngAfterViewInit(): void {
    // Start at first section
    this.scrollToSection(0);
  }

  // ==============================
  // FULL PAGE SCROLL (MOUSE)
  // ==============================

  // @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {

    if (this.isScrolling) return;

    if (event.deltaY > 0) {
      this.goNext();
    } else {
      this.goPrevious();
    }
  }

  // ==============================
  // FULL PAGE SCROLL (KEYBOARD)
  // ==============================

  // @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (this.isScrolling) return;

    switch (event.key) {

      case 'ArrowDown':
      case 'PageDown':
        event.preventDefault();
        this.goNext();
        break;

      case 'ArrowUp':
      case 'PageUp':
        event.preventDefault();
        this.goPrevious();
        break;

      case ' ':
        event.preventDefault();
        this.goNext();
        break;
    }
  }

  // ==============================
  // SECTION NAVIGATION
  // ==============================

  private goNext(): void {
    if (this.currentIndex < this.sections.length - 1) {
      this.currentIndex++;
      this.scrollToSection(this.currentIndex);
    }
  }

  private goPrevious(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToSection(this.currentIndex);
    }
  }

  private scrollToSection(index: number): void {

    this.isScrolling = true;
    this.currentIndex = index;

    // If top section → force absolute top
    if (index === 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      const element = this.sections.toArray()[index].nativeElement;

      const offsetTop = element.offsetTop;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }

    setTimeout(() => {
      this.isScrolling = false;
    }, 900);
  }

  // ==============================
  // TESTIMONIALS HORIZONTAL SCROLL
  // ==============================

  public scrollRight(): void {
    if (window.innerWidth > 600) {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft + 600,
        behavior: 'smooth'
      });
    } else {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft + window.innerWidth,
        behavior: 'smooth'
      });
    }
  }

  public scrollLeft(): void {
    if (window.innerWidth > 600) {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft - 650,
        behavior: 'smooth'
      });
    } else {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft - window.innerWidth,
        behavior: 'smooth'
      });
    }
  }

  // ==============================
  // ROUTING
  // ==============================

  onClickExploreCourses(): void {
    this.router.navigate(['pricing']);
    sessionStorage.setItem('activeSection', JSON.stringify('pricing'));
  }

  onClickCourse(course: any): void {
    this.router.navigate(['courses/details/' + course._id]);
  }

  onClickKnowMore(): void {
    this.router.navigate(['about']);
  }
}